import React from 'react';

function cardTrend(props) {
  return (
  <div className="card-trend">
    <img src={props.image} alt={props.heading} />
    <div className="card-trend__content">
      <a href={props.link} title={props.sub_heading} target="_blank" rel="noopener noreferrer">
        <div className="card-trend__heading">
          <h4>{props.sub_heading}</h4>
          <h3>{props.heading}</h3>
        </div>        
      </a>
    </div>
  </div>
  )
}

export default cardTrend